
<ul ngbNav #nav="ngbNav" [(activeId)]="ActiveId" (activeIdChange)="activeIdChange()" class="nav-tabs">
  <li ngbNavItem="Attività" >
    <a ngbNavLink> {{'Attività'|translate}} </a>
    <ng-template ngbNavContent>
      <app-lista-interventi-offerta #lista [EditInModal]="true" [hasFilter]="true" ></app-lista-interventi-offerta>
    </ng-template>
  </li>
  <li ngbNavItem="Gantt" >
    <a ngbNavLink> {{'Gantt'|translate}} </a>
    <ng-template ngbNavContent>
      <app-gantt></app-gantt>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
